import defaultPerson from './default-person';
import getParams from './get-params';
import apiConnection from './apiConnection';

export default {
  getParams,
  personCollection: getParams['coll'] || 'persons',
  apiBaseUri: apiConnection.apiBaseUri,
  socket: apiConnection.socket,
  imgUploader: apiConnection.imgUploader,
  routerHistory: [],
  defaultPerson,
  persons: [],
};
